import { client } from './contentfulClient';
import { fixLocale } from './page';

// async/await style
export const getEntries = async (
  id?: string,
  locale: string = 'en-US',
  token = process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
  host = 'cdn.contentful.com',
): Promise<any> => {
  try {
    const results = await client(token, host).getEntries({
      'sys.id': id,
      include: 10,
      locale: fixLocale(locale),
    });
    return results.items[0];
  } catch (error) {
    console.error('Error fetching entry:', error);
    throw error;
  }
};
